/**
 * A patch to make global jQuery work with ES6 modules
 */
import jquery from "jquery";
window.jQuery = jquery;
window.$ = jquery;
